export default {
  gradeMobile: {
    id: 'list_view_product_thumb_grade_mobile',
    defaultMessage: '{grade}:',
  },
  releaseLabel: {
    id: 'list_view_product_thumb_large_release_label',
    defaultMessage: 'Release date:',
  },
  coreLabel: {
    id: 'list_view_product_thumb_large_core_label',
    defaultMessage: 'Core:',
  },
  keyboardLabel: {
    id: 'list_view_product_thumb_large_keyboard_label',
    defaultMessage: 'Keyboard:',
  },
  capacityLabel: {
    id: 'list_view_product_thumb_large_capacity_label',
    defaultMessage: 'Capacity:',
  },
  capacityValue: {
    id: 'list_view_product_thumb_large_capacity_value',
    defaultMessage: '{storageValue} {storageType}',
  },
  memoryLabel: {
    id: 'list_view_product_thumb_large_memory_label',
    defaultMessage: 'Memory:',
  },
  warrantyLabel: {
    id: 'list_view_product_thumb_large_warranty_label',
    defaultMessage: 'Warranty:',
  },
  processor: {
    id: 'list_view_product_thumb_processor',
    defaultMessage: '{processorSpeed}GHz',
  },
  startingFrom: {
    id: 'list_view_starting_from',
    defaultMessage: 'starting from:',
  },
  notDefinedAttribute: {
    id: 'list_view_not_defined_attribute',
    defaultMessage: 'ND',
  },
}
